type IconProps = React.ComponentProps<'svg'>

export function ChevronLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(8.25, 5.25)">
        <path
          d="M6.21967 0.21967C6.51256 -0.0732233 6.98732 -0.0732233 7.28022 0.21967C7.57305 0.512568 7.57309 0.987342 7.28022 1.28022L1.81049 6.74994L7.28022 12.2197C7.57305 12.5126 7.57309 12.9873 7.28022 13.2802C6.98734 13.5731 6.51257 13.5731 6.21967 13.2802L0.21967 7.28022C-0.0732233 6.98732 -0.0732232 6.51256 0.21967 6.21967L6.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
